import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TramiteSuperfinancieraDto } from '../../../../dto/tramites/tramite-superfinanciera.dto';
import { AnexoPrecargaResponseDto } from '../../../../dto/anexo/anexo-tramite.dto';
import { ArchivosFormDTO } from '../../../../dto/expediente/archivos-form.dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormField } from '../../../../dto/util/form-field';
import { PersonaDto } from '../../../../dto/tramites/persona.dto';
import { PaisDto } from '../../../../dto/expediente/pais.dto';
import { Constants } from '../../../../constants/constants';
import { TipoAnexoTipoTramiteDto } from '../../../util/archivos-tramite/dto/tipo-anexo-tipo-tramite.dto';
import { TableColumn } from '../../../../dto/util/table-column';
import { TableAction } from '../../../../dto/util/table-action';
import { ConfigurarCuentasService } from '../../../configuracion-cuenta/services/configurar-cuentas.service';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ListasService } from '../../../../services/listas.service';
import { TextTransformService } from '../../../util/text-transform/text-transform.service';
import { DatosAdicionalesService } from '../../../util/modal-datos/services/datos-adicionales.service';
import { CargueArchivosTramiteService } from '../../../util/archivos-tramite/services/cargue-archivos-tramite.service';
import { PersonaLoginDTO } from '../../../../dto/util/persona.dto';
import { TipoDocumentoDto } from '../../../../dto/expediente/tipo-documento.dto';
import { ArchivoItemDto } from '../../../util/archivos-tramite/dto/ArchivoItemDto';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-sfc-apoderado',
  templateUrl: './sfc-apoderado.component.html',
  styleUrl: './sfc-apoderado.component.scss'
})
export class SfcApoderadoComponent implements OnInit, OnChanges {

  @Input() tramiteSfc?: TramiteSuperfinancieraDto;
  @Input() archivosPreCargados?: AnexoPrecargaResponseDto[];
  @Output() continuar = new EventEmitter<{
    tramite: TramiteSuperfinancieraDto;
    formValid: boolean;
    event: Event;
  }>();
  @Output() guardarSinEnviar = new EventEmitter<{
    tramite: TramiteSuperfinancieraDto;
    formValid: boolean;
    event: Event;
  }>();
  @Input() volver: boolean = false;
  @Output() apoderadoEmit = new EventEmitter<{
    formApoderado: FormGroup;
  }>();
  // Multilenguaje
  sfcText: any = {};
  comunText: any = {};
  alertaText: any = {};

  dataUsuario!: PersonaLoginDTO;
  demandantes: PersonaDto[] = [];
  demandados: PersonaDto[] = [];
  apoderados: PersonaDto[] = [];

  formFieldTieneApoderado: FormField[] = [];
  formFieldApoderado: FormField[] = [];
  formTieneApoderado!: FormGroup;
  formApoderado!: FormGroup;

  paises: PaisDto[] = [];

  public entidadId: number = Constants.ID_ENTIDAD_SUPERFINANCIERA;
  // seteo inputs otro Departamento y municipio
  auxIdCountry: number[] = [];


  anexoPoderJudicial: ArchivosFormDTO | null = null;

  // Tabla
  columnsApoderado: TableColumn[] = [];
  actions: TableAction[] = [];
  dataTableApoderados: PersonaDto[] = [];
  indexEditarApoderado: number | undefined = undefined;

  // listas
  tiposDocumento: TipoDocumentoDto[] = [];

  // Archivo
  mostrarComponenteCarga: boolean = true;
  enviarDocumentos = false;
  enviar = false;
  archivosCargados: ArchivoItemDto[] = [];
  anexosTramiteObligatorios: TipoAnexoTipoTramiteDto[] = [];

  // Listas de ids documentos requeridos por pasos
  idsFilesPasoAbogado: TipoAnexoTipoTramiteDto[] = [];

  pesoTotalArchivosMB: string = '0.00';

  existePersona: boolean = false;

  buildForm() {
    this.formFieldTieneApoderado = [
      {
        name: 'tieneApoderado',
        label: `¿${this.comunText['utiliza-abogado']}?`,
        type: 'select',
        required: true,
        width: '12',
        visible: true,
        options: [
          { Id: 1, Nombre: this.comunText['opcion-si'] },
          { Id: 2, Nombre: this.comunText['opcion-no'] },
        ],
        errorMessages: {
          required:
            this.sfcText['tramite-sic-comp-desleal']['seleccione-opcion'],
        },
      }
    ]
    this.formFieldApoderado = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        personTypeId: '1',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [Validators.minLength(4)],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          minlength: this.comunText['numero-documento-minlength'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'address',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['country-required'] },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['departament-required'] },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: false,
        errorMessages: { required: this.comunText['municipality-required'] },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength:
            this.sfcText['tramite-sic-comp-desleal']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip:
          this.sfcText['tramite-sic-comp-desleal']['escriba-departamento'],
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.sfcText['tramite-sic-comp-desleal']['campo-required'],
          maxlength:
            this.sfcText['tramite-sic-comp-desleal']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.sfcText['tramite-sic-comp-desleal']['escriba-municipio'],
      },
      {
        name: 'professionalCard',
        label: this.comunText['tarjeta-profesional'],
        type: 'text',
        required: true,
        placeholder: this.comunText['tarjeta-profesional-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(12),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['tarjeta-profesional-required'],
          minlength: this.comunText['tarjeta-profesional-minlength'],
          maxlength: this.comunText['tarjeta-profesional-maxlength'],
          pattern: this.comunText['tarjeta-profesional-pattern'],
        },
      },
      {
        name: 'email',
        label: this.comunText['correo-judicial'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '12',
        visible: true,
        validation: [
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
        errorMessages: {
          required: this.comunText['email-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
    ];
  }

  constructor(
    private readonly fb: FormBuilder,
    private readonly configurarCuentaService: ConfigurarCuentasService,
    private readonly alertaModalService: AlertaModalService,
    private readonly translate: TranslateService,
    private readonly listaServices: ListasService,
    private readonly textTransformService: TextTransformService,
    private readonly datosProvisionalesService: DatosAdicionalesService,
    private readonly cargueArchivosService: CargueArchivosTramiteService,
    private readonly _cuentaService: ConfigurarCuentasService,
  ) {
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
    this.formApoderado = this.fb.group({
    });
  }

  ngOnInit() {
    this.listaServices.getCountryList().subscribe((countries: PaisDto[]) => {
      this.paises = countries;
    });
    combineLatest({
      tramites: this.translate.stream('tramites'),
      comun: this.translate.stream('comun-label'),
      alertas: this.translate.stream('alertas'),
    }).subscribe(({ tramites, comun, alertas }) => {
      // Asignar traducciones a variables
      this.sfcText = tramites;
      this.comunText = comun;
      this.alertaText = alertas;
      // Construir formularios después de cargar traducciones
      this.buildForm();
      this.iniciarColumnas()
    });
    this.getTypeDocuments();
  }

  /* listas */
  getTypeDocuments() {
    this.listaServices
      .getDocumentTypeList()
      .subscribe((documentTypes: TipoDocumentoDto[]) => {
        this.tiposDocumento = documentTypes.map(documentType => ({
          Id: documentType.Id,
          TipoDocumento: documentType.Tipo_Documento,
        }));
      });
  }

  // Metodo que filtra el tipo de documentos para apoderado, quitando TI
  getListaDocumentosApoderado() {
    this.formFieldApoderado = this.formFieldApoderado.map((field: FormField) => {
      if (field.name === 'typeOfDocument' && field.options?.length) {
        const filteredOptions =
          field.options?.filter(option => option.Id !== 5) || [];
        return { ...field, options: filteredOptions };
      }
      return field;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteSuperfinancieraDto =
      changes['tramiteSfc'].currentValue;
    //Si el tramite cambia, se seta toda la informacion del mismo
    if (tramite !== undefined) {
      this.tramiteSfc = tramite;
      if (tramite?.apoderados !== undefined) {
        if (Array.isArray(tramite.apoderados) && tramite.apoderados.length > 0) {
          for (const apoderado of tramite.apoderados) {
            if (
              !this.apoderados.some(
                dem =>
                  dem.idTipoIdentificacion == apoderado.idTipoIdentificacion &&
                  dem.identificacion == apoderado.identificacion
              )
            ) {
              if (apoderado.idTipoPersona == Constants.TIPO_PERSONA.NATURAL) {
                apoderado.datosRepresentanteLegal = null;
              }
              this.apoderados.push(apoderado);
              sessionStorage.setItem('apoderados', JSON.stringify(this.apoderados));
            }
          }

          this.dataTableApoderados = this.apoderados.filter(
            item => item.idTipoPersona === 1
          );

          this.iniciarColumnas();
          this.formTieneApoderado.get('tieneApoderado')?.setValue(1);
          this.formFieldTieneApoderado = this.formFieldTieneApoderado.map(field => {
            if (field.name === 'tieneApoderado') {
              field.value = 1;
            }
            return field;
          });
        } else {
          this.formTieneApoderado.get('tieneApoderado')?.setValue(2);
          this.formFieldTieneApoderado = this.formFieldTieneApoderado.map(field => {
            if (field.name === 'tieneApoderado') {
              field.value = 2;
            }
            return field;
          });
          this.apoderados = [];
          this.dataTableApoderados = [];
        }
      } else {
        this.getData();
      }
    } else {
      this.getData();
    }
  }

  private iniciarColumnas() {
    this.columnsApoderado = [
      {
        field: 'primerNombre',
        title: this.comunText['primer-nombre'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'primerApellido',
        title: this.comunText['primer-apellido'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'identificacion',
        title: this.comunText['numero-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'tarjetaProfesional',
        title: this.comunText['tarjeta-profesional'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];

    this.actions = [
      {
        type: 'button',
        title: '',
        icon: 'pencil-square-o',
        idAccion: '2',
      },
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: '1',
      },
    ];
  }

  onChangeTieneApoderado($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    this.formTieneApoderado = $event.form;
    if (this.formTieneApoderado?.get('tieneApoderado')?.value == '1') {
      setTimeout(() => {
        this.getListaDocumentosApoderado();
      }, 500)
    }
  }

  onChangeApoderado($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    // setTimeout(() => {
    //   this.formApoderado = $event.form;
    // }, 100);
    let formGroup = $event.form;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    let identificacion: string = formGroup?.get('numberOfDocument')?.value;
    const numeroDocumentoApoderado = this.formFieldApoderado.find(
      field => field.name == 'numberOfDocument'
    );
    if (
      $event.controlName == 'typeOfDocument' ||
      $event.controlName == 'numberOfDocument'
    ) {
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento === 5 ||
          idTipoDocumento === 2
        ) {
          if (numeroDocumentoApoderado != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoApoderado.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoApoderado.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoApoderado.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoApoderado != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(8),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumentoApoderado.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoApoderado.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoApoderado.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        }
        formGroup?.get('numberOfDocument')?.updateValueAndValidity();
      }
    }

    if ($event.controlName == 'country' || formGroup?.get('country')?.value) {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      const idPaisSeleccionado = +formGroup?.get('country')?.value;
      if (idPais === idPaisSeleccionado) {
        formGroup?.controls['departament']?.addValidators(Validators.required);
        formGroup?.controls['municipality']?.addValidators(Validators.required);
        formGroup?.controls['otroDepartamento']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.removeValidators(
          Validators.required
        );
        formGroup?.get('otroMunicipio')?.updateValueAndValidity();
        formGroup?.get('otroDepartamento')?.updateValueAndValidity();
      } else {
        let clearInputs: boolean = false
        if (formGroup?.controls['country'].value) {
          this.auxIdCountry.push(formGroup?.controls['country'].value)
          if (this.auxIdCountry.length > 1) {
            clearInputs = formGroup?.controls['country'].value != this.auxIdCountry[this.auxIdCountry.length - 2]
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamento'].setValue('')
          formGroup?.controls['otroMunicipio'].setValue('')
        }
        formGroup?.controls['departament']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['municipality']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroDepartamento']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipio']?.markAsDirty();
        formGroup?.controls['otroMunicipio']?.markAllAsTouched();
        formGroup?.get('otroMunicipio')?.updateValueAndValidity();
        formGroup?.get('otroDepartamento')?.updateValueAndValidity();
        this.formFieldApoderado.forEach((field: FormField) => {
          if (['otroMunicipio', 'otroDepartamento']
            .includes(field.name)
          ) {
            field.required = true
          }
        });

      }
      // this.mostrarCamposRequeridos(formGroup)
    }
    // if (this.formApoderado?.valid) {
    //   this.apoderadoEmit.emit({
    //     formApoderado: this.formApoderado,
    //   });
    // }
  }

  changeActionApoderado(formGroup: FormGroup) {
    if (formGroup) {
      this.formApoderado = formGroup
      this.apoderadoEmit.emit({
        formApoderado: this.formApoderado,
      });
    }
  }

  // Agregar apoderado
  agregarApoderado(guardarSinEnviar: boolean = false): boolean {
    const apoderado = this.construirApoderado();
    // Validar datos mínimos
    if (!this.validarDatosClave(apoderado)) {
      return false;
    }

    // Validar duplicados dentro de apoderados locales
    if (!this.validarDuplicados(apoderado)) {
      return false;
    }

    // Validar que no esté en demandantes/demandados
    if (!this.validarNoEnDemandadosNiDemandantes(apoderado)) {
      return false;
    }
    // Guardar en sessionStorage
    this.guardarApoderadoEnSession(apoderado);

    if (!guardarSinEnviar) {
      this.mostrarAlertaAgregado();
    }

    this.reiniciarFormularios();

    this.indexEditarApoderado = undefined;
    this.auxIdCountry = [];

    return true;
  }

  private construirApoderado(): PersonaDto {
    return {
      idTipoPersona: 1,
      idTipoIdentificacion: this.formApoderado.get('typeOfDocument')?.value,
      identificacion: this.formApoderado.get('numberOfDocument')?.value,
      primerNombre: this.formApoderado.get('primerNombre')?.value,
      segundoNombre: this.formApoderado.get('segundoNombre')?.value,
      primerApellido: this.formApoderado.get('primerApellido')?.value,
      segundoApellido: this.formApoderado.get('segundoApellido')?.value,
      correoElectronico: this.formApoderado.get('email')?.value,
      direccionPersona: [
        { direccionNotificacion: this.formApoderado.get('address')?.value }
      ],
      municipio: {
        id: Number(this.formApoderado.get('municipality')?.value),
        idDepartamento: Number(this.formApoderado.get('departament')?.value),
        idPais: +this.formApoderado.get('country')?.value
      },
      tarjetaProfesional: this.formApoderado.get('professionalCard')?.value,
      departamentoExtranjero: this.formApoderado.get('otroDepartamento')?.value,
      ciudadExtranjero: this.formApoderado.get('otroMunicipio')?.value,
    };
  }

  private validarDatosClave(apoderado: PersonaDto): boolean {
    return !!(apoderado.idTipoIdentificacion && apoderado.identificacion);
  }

  private validarDuplicados(apoderado: PersonaDto): boolean {
    if (this.indexEditarApoderado !== undefined) return true;

    const existe = this.apoderados.some(item =>
      item.idTipoIdentificacion == apoderado.idTipoIdentificacion &&
      String(item.identificacion) == String(apoderado.identificacion)
    );

    if (existe) {
      this.existePersona = true;
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['asuntos-alertas']['apoderado-ya-agregado']
      );
      return false;
    }

    return true;
  }

  private validarNoEnDemandadosNiDemandantes(apoderado: PersonaDto): boolean {
    this.demandados = JSON.parse(sessionStorage.getItem('demandados') || '[]');
    this.demandantes = JSON.parse(sessionStorage.getItem('demandantes') || '[]');

    const existeEnDemandado = this.searchInDemandados(
      apoderado.idTipoIdentificacion!,
      +apoderado.identificacion!
    );

    const existeEnDemandante = this.searchInDemandantes(
      apoderado.idTipoIdentificacion!,
      +apoderado.identificacion!
    );

    if (existeEnDemandado || existeEnDemandante) {
      this.existePersona = true;
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['sic-comp-desleal-alertas']['existe']
      );
      return false;
    }

    return true;
  }

  private guardarApoderadoEnSession(apoderado: PersonaDto): void {
    let apoderados: PersonaDto[] = JSON.parse(sessionStorage.getItem('apoderados') || '[]');
    if (this.indexEditarApoderado !== undefined) {
      apoderados[this.indexEditarApoderado] = apoderado;
    } else {
      const existeIdx = apoderados.findIndex(a =>
        String(a.identificacion) === String(apoderado.identificacion) &&
        a.idTipoIdentificacion === apoderado.idTipoIdentificacion
      );
      if (existeIdx === -1) {
        apoderados.push(apoderado);
      } else {
        return;
      }
    }

    this.apoderados = apoderados.filter(a => Object.keys(a).length > 0);
    sessionStorage.setItem('apoderados', JSON.stringify(this.apoderados));
    this.dataTableApoderados = this.apoderados.filter(
      item => item.idTipoPersona === Constants.TIPO_PERSONA.NATURAL
    );

    this.iniciarColumnas();
  }


  private mostrarAlertaAgregado(): void {
    if (this.formTieneApoderado.get('tieneApoderado')?.value == 1) {
      this.alertaModalService.exito(
        this.alertaText['agregado'],
        this.alertaText['asuntos-alertas']['apoderado-agregado']
      );
    }
  }


  searchInDemandados(idTipoDocumento: number, identificacion: number): boolean {
    if (!this.demandados) return false;

    const existe = this.demandados.some(elemento =>
      elemento.idTipoIdentificacion == idTipoDocumento &&
      +elemento.identificacion! == identificacion
    );

    if (existe) {
      this.alertaModalService.advertencia(
        this.alertaText['tipo-numero-documento-existe-demandado']
      );
    }

    return existe;
  }

  searchInDemandantes(idTipoDocumento: number, identificacion: number): boolean {
    if (!this.demandantes) return false;

    const existe = this.demandantes.some(elemento =>
      elemento.idTipoIdentificacion == idTipoDocumento &&
      +elemento.identificacion! == identificacion
    );

    if (existe) {
      this.alertaModalService.advertencia(
        this.alertaText['tipo-numero-documento-existe-demandante']
      );
    }

    return existe;
  }


  // Acciones apoderado

  accionesApoderado(event: any) {
    const persona = event.item as PersonaDto;
    if (event.idAccion == '2') { // editar
      this.indexEditarApoderado = event.index;
      this.setearDatosApoderado(persona);
    } else if (event.idAccion == '1') { // eliminar
      this.alertaModalService.confirmacion(
        this.alertaText['sic-procon-alertas']['eliminar-registro'],
        '',
        () => {
          this.apoderados = this.apoderados.filter(item => item !== persona);

          this.dataTableApoderados = this.apoderados.filter(
            item => item.idTipoPersona === 1
          );
          sessionStorage.setItem('apoderados', JSON.stringify(this.apoderados));
          this.iniciarColumnas();
        },
        () => { }
      );
    }
  }

  setearDatosApoderado(persona: PersonaDto) {
    this.formFieldTieneApoderado = this.formFieldTieneApoderado.map(field => {
      if (field.name == 'tieneApoderado') {
        field.value = 1;
      }
      return field;
    });
    setTimeout(() => {
      this.formFieldApoderado = this.formFieldApoderado.map(field => {
        switch (field.name) {
          case 'typeOfDocument':
            field.value = persona.idTipoIdentificacion;
            break;
          case 'numberOfDocument':
            field.value = persona.identificacion;
            break;
          case 'primerNombre':
            field.value = persona.primerNombre;
            break;
          case 'segundoNombre':
            field.value = persona.segundoNombre;
            break;
          case 'primerApellido':
            field.value = persona.primerApellido;
            break;
          case 'segundoApellido':
            field.value = persona.segundoApellido;
            break;
          case 'email':
            field.value = persona.correoElectronico;
            break;
          case 'country':
            field.value = persona.municipio?.idPais;
            break;
          case 'departament':
            field.value = persona.municipio?.idDepartamento;
            break;
          case 'municipality':
            field.value = persona.municipio?.id;
            break;
          case 'otroDepartamento':
            field.value = persona?.departamentoExtranjero?.toString();
            break;
          case 'otroMunicipio':
            field.value = persona.ciudadExtranjero?.toString();
            break;
          case 'address':
            field.value = persona.direccionPersona?.[0]?.direccionNotificacion;
            break;
          case 'professionalCard':
            field.value = persona.tarjetaProfesional;
            break;

        }
        return field;
      });
    }, 800);
  }

  reiniciarFormularios() {
    if (!this.existePersona) {
      setTimeout(() => {
        this.formApoderado.reset();
        this.formFieldApoderado = this.formFieldApoderado.map(field => {
          field.value = undefined;
          field.disabled = false;
          return field;
        });
      }, 0);
    } else {
      this.formApoderado.get('numberOfDocument')?.setErrors({ incorrect: true });
    }

  }

  cancelarEditarDemandante() {
    this.indexEditarApoderado = undefined;
    this.formApoderado.reset();
  }

  seguirConDemandado(e: Event, guardarSinEnviar: boolean) {
    const tieneApoderado = this.formTieneApoderado.get('tieneApoderado')?.value;

    if (!guardarSinEnviar) {
      if (!this.validarForm()) {
        this.formTieneApoderado.markAllAsTouched();
        this.formApoderado?.markAllAsTouched?.();
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['form_invalid']
        );
        return;
      }
      if (tieneApoderado == 1) {
        if (!this.validarDocumentosObligatorios()) {
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['archivos_obligatorios']
          );
          return;
        }
      }
    }


    if (tieneApoderado != 1) {
      this.apoderados = [{}];
      sessionStorage.setItem('apoderados', JSON.stringify(this.apoderados));
    } else {

      // Si es guardar sin enviar: agregar aunque el form no esté válido
      if (guardarSinEnviar) {        
        const tieneDatos =
          this.formApoderado.get('typeOfDocument')?.value ||
          this.formApoderado.get('numberOfDocument')?.value;

        // Si NO hay datos del apoderado, NO llamar agregarApoderado()
        if (!tieneDatos) {
          // Solo recargar lo que haya en session (si lo necesitas)
          this.apoderados = JSON.parse(sessionStorage.getItem('apoderados') ?? '[]');
        } else {
          // Si sí escribió algo, pero no está completo: permitir guardar igual
          const agregado = this.agregarApoderado(true);
          if (!agregado) return;
        }
      }

      // Si NO es guardar sin enviar: solo agregar si el form es válido
      else {
        if (this.formApoderado?.valid) {
          const agregado = this.agregarApoderado(false);
          if (!agregado) return;
        } 
      }
    }

    const tramite: TramiteSuperfinancieraDto = {
      id: this.tramiteSfc ? this.tramiteSfc.id : null,
      idTipoTramite: Constants.SFC_PROCON,
      esParcial: true,
      enviar: false,
      apoderados: this.apoderados,
      usuario: { id: this.dataUsuario.idUsuario },
      paso: 2,
      tieneApoderado: tieneApoderado == 1,
    };

    if (!guardarSinEnviar) {
      let paso = JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
      if (paso) {
        sessionStorage.setItem(Constants.PASOS, JSON.stringify(3));
      }
      this.enviar = false;
      this.continuar.emit({
        tramite,
        formValid: this.habilitarBoton(),
        event: e,
      });
    } else {
      this.guardarSinEnviar.emit({
        tramite,
        formValid: this.habilitarBoton(),
        event: e,
      });
    }

    this.enviarDocumentos = true;
  }

  atras() {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      paso--;
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(paso));
    }
  }


  habilitarBoton(): boolean {
    if (this.formTieneApoderado.get('tieneApoderado')?.value !== 1) {
      return true;
    }

    if (!this.apoderados || this.apoderados.length === 0) {
      return false;
    }

    return this.apoderados.every(a =>
      !!a.idTipoPersona &&
      !!a.idTipoIdentificacion &&
      !!a.identificacion &&
      !!a.primerNombre &&
      !!a.primerApellido &&
      !!a.fechaNacimiento &&
      !!a.telefonoPrincipal &&
      !!a.correoElectronico &&
      !!a.idSexo &&
      !!(a.direccionPersona?.[0]?.direccionNotificacion ||
        a.departamentoExtranjero ||
        a.ciudadExtranjero) &&
      !!a.municipio?.id &&
      !!a.municipio?.idDepartamento &&
      !!a.municipio?.idPais
    );
  }

  renombarArchivo(archivo: File, nuevoNombre: string): File {
    return new File([archivo], nuevoNombre, {
      type: archivo.type,
      lastModified: archivo.lastModified,
    });
  }

  // Setear datos iniciales si es abogado
  getData() {
    const user_type = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
    this.getDataUser(this.dataUsuario.idUsuario!);
    if (user_type.Nombre == 'Abogado') {
      if (this.dataUsuario) {
        this.getDataUsuario(this.dataUsuario?.idPersona!)
      }
    }
  }

  getDataUsuario(idPersona: number) {
    let tarjeta: number = 0;
    this.datosProvisionalesService
      .getDataAbogado(idPersona)
      .subscribe((response: any) => {
        tarjeta = response.datoAdicionalAbogado.Tarjeta_Profesional;
        this.formFieldTieneApoderado = this.formFieldTieneApoderado.map(field => {
          if (field.name == 'tieneApoderado') {
            field.value = 1;
          }
          return field;
        });
        setTimeout(() => {
          this.formFieldApoderado = this.formFieldApoderado.map(
            (field: FormField) => {
              switch (field.name) {
                case 'primerNombre':
                  field.value = this.dataUsuario?.primerNombre
                    ? this.dataUsuario?.primerNombre
                    : undefined;
                  break;
                case 'segundoNombre':
                  field.value = this.dataUsuario?.segundoNombre
                    ? this.dataUsuario?.segundoNombre
                    : undefined;
                  break;
                case 'primerApellido':
                  field.value = this.dataUsuario?.primerApellido
                    ? this.dataUsuario?.primerApellido
                    : undefined;
                  break;
                case 'segundoApellido':
                  field.value = this.dataUsuario?.segundoApellido
                    ? this.dataUsuario?.segundoApellido
                    : undefined;
                  break;
                case 'typeOfDocument':
                  field.value = this.getIdDocumento(
                    String(this.dataUsuario?.tipoDocumento)
                  );
                  break;
                case 'numberOfDocument':
                  field.value = this.dataUsuario?.identificacion
                    ? this.dataUsuario?.identificacion
                    : undefined;
                  break;
                case 'country':
                  field.value = this.dataUsuario?.pais;
                  break;
                case 'departament':
                  field.value = this.dataUsuario?.departamento;
                  break;
                case 'municipality':
                  field.value = this.dataUsuario?.municipio;
                  break;
                case 'otroDepartamento':
                  field.value = this.dataUsuario?.otroDepartamento ?? undefined;
                  break;
                case 'otroMunicipio':
                  field.value = this.dataUsuario?.otroMunicipio ?? undefined;
                  break;
                case 'email':
                  field.value = this.dataUsuario?.correoElectronico;
                  break;
                case 'address':
                  field.value = this.dataUsuario?.direccion?.find(
                    (elemento: {
                      Direccion_Notificacion?: string;
                      Es_Primaria?: boolean;
                      Id?: number
                    }) => elemento.Es_Primaria
                  )?.Direccion_Notificacion ??
                    this.dataUsuario?.direccion?.[0]?.Direccion_Notificacion ?? '';
                  break;
                case 'professionalCard':
                  field.value = tarjeta ?? undefined;
                  break;
              }
              return field;
            }
          );
        }, 800);
      })
  }

  getDataUser(idUsuario: number) {
    this._cuentaService
      .getDataPersonal(idUsuario)
      .subscribe((response: any) => {
        if (response.status == 200) {
          this.dataUsuario.otroDepartamento = response.data.Otro_Departamento;
          this.dataUsuario.otroMunicipio = response.data.Otro_Municipio;
        }
      });
  }

  getIdDocumento(tipoDocumento: string): number {
    if (typeof tipoDocumento == 'string') {
      const documento = this.tiposDocumento.find(
        (elemento: any) => elemento.TipoDocumento === tipoDocumento
      );
      return +documento?.Id!;
    } else {
      return tipoDocumento[0];
    }
  }

  validarForm(): boolean {
    if (this.formTieneApoderado.get('tieneApoderado')?.value == '1') {
      if (this.formApoderado?.valid) {
        return true;
      } else {
        return this.validarFormSinEnviar();
      }
    } else if (this.formTieneApoderado.get('tieneApoderado')?.value == '2') {
      return true;
    } else {
      return false;
    }
  }

  validarFormSinEnviar(): boolean {
    if (!this.apoderados || this.apoderados.length === 0) {
      return false;
    }
    return this.apoderados.every((d) => {
      const esExtranjero = d.municipio?.idPais != Constants.ID_COLOMBIA;

      let validacionUbicacion = false;

      if (esExtranjero) {
        const departamento = this.obtenerDepartamento(d);
        const municipio = this.obtenerMunicipio(d);
        validacionUbicacion = !!departamento && !!municipio;
      } else {
        validacionUbicacion =
          !!d.municipio?.idDepartamento && !!d.municipio?.id;
      }

      if (!d.idTipoIdentificacion) return false;
      if (!d.identificacion) return false;

      const patternIdentificacion = this.getPatternIdentificacion(d.idTipoIdentificacion);
      if (!patternIdentificacion.test(d.identificacion)) {
        return false;
      }

      if (
        !d.correoElectronico ||
        !(new RegExp(Constants.REGEX_CORREO_ELECTRONICO)).test(d.correoElectronico)
      ) {
        return false;
      }
      if (!d.direccionPersona?.[0]?.direccionNotificacion) {
        return false;
      }

      if (!d.tarjetaProfesional) {
        return false;
      }


      const regexNombre = new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT);

      if (!d.primerNombre || !regexNombre.test(d.primerNombre)) return false;
      if (d.segundoNombre && !regexNombre.test(d.segundoNombre)) return false;
      if (!d.primerApellido || !regexNombre.test(d.primerApellido)) return false;
      if (d.segundoApellido && !regexNombre.test(d.segundoApellido)) return false;

      if (!validacionUbicacion) return false;

      return true;
    });
  }

  private obtenerDepartamento(persona: PersonaDto): string | undefined {
    return persona.otroDepartamento && persona.otroDepartamento.trim() !== ''
      ? persona.otroDepartamento
      : persona.departamentoExtranjero || undefined;
  }

  private obtenerMunicipio(persona: PersonaDto): string | undefined {
    return persona.otroMunicipio && persona.otroMunicipio.trim() !== ''
      ? persona.otroMunicipio
      : persona.ciudadExtranjero || undefined;
  }

  getPatternIdentificacion(tipoDocumentoId: number): RegExp {
    switch (tipoDocumentoId) {
      case 1:
      case 2:
        return /^\d{4,12}$/;
      case 4:
        return /^[a-zA-Z0-9]{4,8}$/;
      case 3:
        return /^\d+$/;
      case 5:
        return /^\d{4,9}$/;
      default:
        return /.*/;
    }
  }


  // Archivo
  subirArchivo(resultado: boolean) {
    this.enviarDocumentos = false;
  }
  validarArchivosCargados(archivos: ArchivoItemDto[], paso: number) {
    if (paso == 2) {
      this.archivosCargados = archivos;
    }
    const anexosRequeridosIds = this.idsFilesPasoAbogado.map(
      (anexo: any) => anexo.id
    );
    const totalBytes = this.archivosCargados.reduce(
      (total, archivo) => total + archivo.files.reduce((sum, file) => sum + file.size, 0),
      0
    );
    this.pesoTotalArchivosMB = (totalBytes / (1024 * 1024)).toFixed(2);

    return this.isEmptyAnexo(this.archivosCargados, anexosRequeridosIds);

  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }

  validarDocumentosObligatorios(): boolean {
    const anexosRequeridosIds = this.idsFilesPasoAbogado.map(
      (anexo: any) => anexo.id
    );
    return this.isEmptyAnexo(this.archivosCargados, anexosRequeridosIds);
  }

  isEmptyAnexo(archivosCargados: ArchivoItemDto[], ids: number[]): boolean {
    let requeridosFull: number = 0;
    let cantidadRequeridos: number = ids.length;
    ids.forEach((elemento: number) => {
      archivosCargados.forEach((anexo: ArchivoItemDto) => {
        if (elemento == anexo.item.id) {
          if (anexo.files.length > 0) {
            requeridosFull++;
          } else {
            requeridosFull--;
          }
        }
      });
    });
    return requeridosFull === cantidadRequeridos;
  }

  getFilesPrecargadosByPaso(paso: number): AnexoPrecargaResponseDto[] {
    return this.archivosPreCargados?.filter(
      elemento => elemento.tipoAnexoTipoTramite.orden === paso
    ) || [];
  }

  getFileRequeridos(evento: { archivos: TipoAnexoTipoTramiteDto[]; paso: number }) {
    if (evento.paso == 2) {
      this.idsFilesPasoAbogado = this.searchRequired(evento.archivos);
    }
  }

  searchRequired(archivos: TipoAnexoTipoTramiteDto[]) {
    archivos = archivos.filter(
      (anexo: any) => anexo.requerido === true
    );
    return archivos;
  }

  validarPaso(): boolean {
    if (this.formTieneApoderado.get('tieneApoderado')?.value == '1') {
      if (this.validarForm() && this.validarDocumentosObligatorios()) {
        return false;
      } else {
        return true;
      }
    } else if (this.formTieneApoderado.get('tieneApoderado')?.value == '2') {
      return false;
    } else {
      return false;
    }

  }


}
